import { useState, useEffect } from 'react';

interface UsageStats {
    currentMonth: {
        totalWordsProcessed: number;
        totalWordsBilled: number;
        totalDocuments: number;
    };
    subscription: {
        planName: string;
        planType: string;
        credits: number;
        price: number;
        status: string;
        billingCycleStart: string;
        billingCycleEnd: string;
    } | null;
    withinLimit: boolean;
    percentageUsed: number;
    upgradeRecommended: boolean;
}

export function useAIHumanITUsage(siteId?: string) {
    const [usage, setUsage] = useState<UsageStats | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!siteId) {
            setLoading(false);
            return;
        }

        const fetchUsage = async () => {
            try {
                setLoading(true);
                const response = await fetch(`/api/sites/${siteId}/aihumanit/usage`);
                
                if (response.ok) {
                    const data = await response.json();
                    setUsage(data);
                    setError(null);
                } else {
                    setError('Failed to fetch usage data');
                }
            } catch (err) {
                setError('Error fetching usage data');
                console.error('Usage fetch error:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchUsage();
        
        // Refresh usage every 30 seconds
        const interval = setInterval(fetchUsage, 30000);
        
        return () => clearInterval(interval);
    }, [siteId]);

    return { usage, loading, error, refetch: () => {
        if (siteId) {
            const fetchUsage = async () => {
                try {
                    const response = await fetch(`/api/sites/${siteId}/aihumanit/usage`);
                    if (response.ok) {
                        const data = await response.json();
                        setUsage(data);
                    }
                } catch (err) {
                    console.error('Usage refetch error:', err);
                }
            };
            fetchUsage();
        }
    }};
}